import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";

/**
 * kbTransclude
 *
 * This is an alternative to ngTransclude, which allows you to select which 
 * scope the transcluded content in the directive should have.
 * This is usefule because the standard ngTransclude will always create 
 * a child scope of the outer scope where the directive is used.
 * Which stops us from using ng-repeat type directives where the transcluded 
 * content accesses something like an item property that is coming
 * from the ng-repeat inside the directive template.  
 * See here for details: https://github.com/angular/angular.js/issues/7874#issuecomment-53450394
 * usage:
 *
 * <div kb-transclude="parent">
 * </div>
 */
@NgComponent({
    token: Token.KbTransclude,
    dependencies: [
    ]
})
export class KbTransclude extends Directive {
    constructor() {
        super();

        this.restrict = "EAC";
        this.link = (scope, element: JQuery, atts, ctrl, $transclude) => {
            if (!$transclude) {
                throw new Error(
                    "Illegal use of ngTransclude directive in the template! " +
                    "No parent directive that requires a transclusion found.");
            }

            let iScopeType = atts.kbTransclude || "outer";
            var slotName = atts.kbTranscludeSlot; //slot name for multi-slot transclusion
            let iChildScope: ng.IScope;
            switch (iScopeType) {
                // this is the default of angular 1.3+... 
                // outer is the controller scope where the directive was originally called from
                case "outer":
                    $transclude(clone => {
                        element.empty();
                        element.append(clone);
                    }, null, slotName);
                    break;
                case "parent": // this will use the scope of the directive
                    $transclude(scope, clone => {
                        element.empty();
                        element.append(clone);
                    }, null, slotName);
                    break;
                case "child": // this will create a new child scope of the directive scope
                    iChildScope = scope.$new();
                    $transclude(iChildScope, clone => {
                        element.empty();
                        element.append(clone);
                        element.on("$destroy", () => {
                            if (iChildScope) {
                                iChildScope.$destroy();
                            }
                        });
                    }, null, slotName);
                    break;
            }

            scope.$on("$destroy", () => {
                if (iChildScope) {
                    iChildScope.$destroy();
                }
            });
        };
    }
}
